import { combineReducers } from 'redux';
import categories from './categories';
import brands from './brands';
import merchants from './merchants';
import home from './home';
import offers from './offers';
import howToBuy from './howToBuy';
import howToBuyProduct from './howToBuyProduct';

const buyWithInstacredLandingPage = combineReducers({
  categories,
  brands,
  merchants,
  home,
  offers,
  howToBuy,
  howToBuyProduct,
});

export default buyWithInstacredLandingPage;



// WEBPACK FOOTER //
// ./reducer/buyWithInstacred/index.js